export default "__VITE_ASSET__DU4cA2PF__"